import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as i1 from '@angular/cdk/platform';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * Overrides OverlayContainer to create Overlays in Theme Scope
 */
class ThemeOverlayContainer extends OverlayContainer {
    constructor(_document, platform) {
        super(_document, platform);
        this.platform = platform;
    }
    registerOverlayContainer(container) {
        this._createContainer();
        this._containerElement.remove();
        container.appendChild(this._containerElement);
    }
}
ThemeOverlayContainer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayContainer, deps: [{ token: DOCUMENT }, { token: i1.Platform }], target: i0.ɵɵFactoryTarget.Injectable });
ThemeOverlayContainer.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayContainer });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayContainer, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.Platform }]; } });

class ThemeOverlayModule {
}
ThemeOverlayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ThemeOverlayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayModule });
ThemeOverlayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayModule, providers: [
        {
            provide: OverlayContainer,
            useClass: ThemeOverlayContainer,
        },
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ThemeOverlayModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: OverlayContainer,
                            useClass: ThemeOverlayContainer,
                        },
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ThemeOverlayContainer, ThemeOverlayModule };
